import ClipboardJS from "clipboard";
import tooltipAction from "../../../components/common/tooltip/index";
function addSnippetCopyEvent(codeSnippet) {
    const copyButtonElement = document.createElement("button");
    copyButtonElement.innerHTML = `
    <svg width="24px" height="24px" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.886 20.6432H7.28099C6.60989 20.6427 5.96644 20.3759 5.4919 19.9013C5.01736 19.4268 4.75053 18.7833 4.75 18.1122V8.77222C4.75053 8.10112 5.01736 7.45765 5.4919 6.98311C5.96644 6.50857 6.60989 6.24174 7.28099 6.24121H13.886C14.5571 6.24174 15.2006 6.50857 15.6751 6.98311C16.1496 7.45765 16.4165 8.10112 16.417 8.77222V18.1122C16.4165 18.7833 16.1496 19.4268 15.6751 19.9013C15.2006 20.3759 14.5571 20.6427 13.886 20.6432ZM7.28099 7.69421C7.13945 7.69382 6.99922 7.72141 6.86838 7.77539C6.73753 7.82937 6.61864 7.90869 6.51855 8.00877C6.41847 8.10886 6.33916 8.22775 6.28517 8.3586C6.23119 8.48944 6.2036 8.62966 6.20399 8.77121V18.1112C6.2036 18.2528 6.23119 18.393 6.28517 18.5238C6.33916 18.6547 6.41847 18.7736 6.51855 18.8737C6.61864 18.9737 6.73753 19.0531 6.86838 19.107C6.99922 19.161 7.13945 19.1886 7.28099 19.1882H13.886C14.0275 19.1886 14.1678 19.161 14.2986 19.107C14.4295 19.0531 14.5484 18.9737 14.6484 18.8737C14.7485 18.7736 14.8278 18.6547 14.8818 18.5238C14.9358 18.393 14.9634 18.2528 14.963 18.1112V8.77121C14.9634 8.62966 14.9358 8.48944 14.8818 8.3586C14.8278 8.22775 14.7485 8.10886 14.6484 8.00877C14.5484 7.90869 14.4295 7.82937 14.2986 7.77539C14.1678 7.72141 14.0275 7.69382 13.886 7.69421H7.28099Z" fill="currentColor" stroke="currentColor" stroke-width="0.3"/>
      <path d="M18.5271 16.846C18.4314 16.8469 18.3364 16.8288 18.2478 16.7925C18.1592 16.7563 18.0787 16.7028 18.011 16.6351C17.9433 16.5674 17.8898 16.4869 17.8535 16.3983C17.8173 16.3097 17.7992 16.2147 17.8001 16.119V7.54898C17.801 7.18928 17.7309 6.83295 17.5938 6.50042C17.4566 6.16789 17.2552 5.86571 17.001 5.61122C16.7468 5.35674 16.4448 5.15496 16.1125 5.01746C15.7801 4.87997 15.4238 4.80945 15.0641 4.80998H9.24411C9.05117 4.80998 8.86611 4.73333 8.72968 4.5969C8.59324 4.46047 8.5166 4.27543 8.5166 4.08248C8.5166 3.88954 8.59324 3.70449 8.72968 3.56806C8.86611 3.43163 9.05117 3.35498 9.24411 3.35498H15.0641C16.1753 3.35525 17.2409 3.79678 18.0266 4.5825C18.8123 5.36822 19.2538 6.43381 19.2541 7.54498V16.114C19.2533 16.3066 19.1765 16.491 19.0403 16.6272C18.9041 16.7633 18.7197 16.8402 18.5271 16.841V16.846Z" fill="currentColor"/>
      <path d="M18.5269 17.0062C18.4101 17.0074 18.2942 16.9853 18.1861 16.9411C18.0779 16.897 17.9796 16.8317 17.897 16.7491C17.8144 16.6665 17.7491 16.5682 17.705 16.4601C17.6608 16.3519 17.6387 16.236 17.6399 16.1192V7.5502C17.6391 6.86751 17.3676 6.21301 16.8849 5.73028C16.4021 5.24754 15.7476 4.97599 15.0649 4.9752H9.24492C9.00954 4.9752 8.78381 4.88169 8.61737 4.71526C8.45093 4.54882 8.35742 4.32308 8.35742 4.0877C8.35742 3.85232 8.45093 3.62658 8.61737 3.46014C8.78381 3.29371 9.00954 3.2002 9.24492 3.2002H15.0649C16.2182 3.20152 17.3239 3.66025 18.1394 4.47575C18.9549 5.29124 19.4136 6.39692 19.4149 7.5502V16.1192C19.4147 16.3544 19.3211 16.5798 19.1548 16.7461C18.9886 16.9124 18.7631 17.0059 18.5279 17.0062H18.5269ZM9.24492 3.5192C9.09441 3.5192 8.95007 3.57899 8.84364 3.68542C8.73722 3.79184 8.67743 3.93619 8.67743 4.0867C8.67743 4.23721 8.73722 4.38156 8.84364 4.48798C8.95007 4.59441 9.09441 4.6542 9.24492 4.6542H15.0649C15.834 4.6542 16.5717 4.95973 17.1155 5.50359C17.6594 6.04744 17.9649 6.78507 17.9649 7.5542V16.1232C17.9641 16.1979 17.9782 16.272 18.0064 16.3411C18.0346 16.4103 18.0764 16.4731 18.1292 16.5259C18.182 16.5787 18.2448 16.6205 18.314 16.6487C18.3832 16.6769 18.4572 16.691 18.5319 16.6902C18.6822 16.6899 18.8263 16.6301 18.9326 16.5238C19.0388 16.4176 19.0986 16.2735 19.0989 16.1232V7.5502C19.0976 6.48179 18.6726 5.4575 17.9171 4.70202C17.1616 3.94653 16.1373 3.52152 15.0689 3.5202L9.24492 3.5192Z" fill="currentColor"/>
    </svg>
  `;
    copyButtonElement.setAttribute("data-clipboard-text", codeSnippet.innerText);
    codeSnippet.appendChild(copyButtonElement);
    let clipboard;
    let tooltipPosition = "bottom";
    let tooltipContent = "Copy";
    let disabledTooltip = true;
    let removeTooltipTimeout = null;
    const showCopiedTooltipDuration = 1400;
    const tooltip = tooltipAction(copyButtonElement, getCurrentTooltipOptions());
    // add clipboard event
    clipboard = new ClipboardJS(copyButtonElement);
    clipboard.on("success", function (e) {
        if (removeTooltipTimeout) {
            clearTimeout(removeTooltipTimeout);
            removeTooltipTimeout = null;
        }
        tooltipContent = "Copied";
        disabledTooltip = false;
        updateTooltipState();
        removeTooltipTimeout = setTimeout(() => {
            disabledTooltip = true;
            removeTooltipTimeout = null;
            updateTooltipState();
        }, showCopiedTooltipDuration);
    });
    function handleButtonMouseEnter() {
        if (removeTooltipTimeout) {
            clearTimeout(removeTooltipTimeout);
            removeTooltipTimeout = null;
        }
        tooltipContent = "Copy";
        disabledTooltip = false;
        updateTooltipState();
    }
    function handleButtonMouseLeave() {
        if (!removeTooltipTimeout) {
            disabledTooltip = true;
        }
        updateTooltipState();
    }
    function getCurrentTooltipOptions() {
        return {
            auto: true,
            content: tooltipContent,
            disabled: disabledTooltip,
            position: tooltipPosition,
            fadeOutAnimation: true,
        };
    }
    function updateTooltipState() {
        const options = getCurrentTooltipOptions();
        tooltip.update(options);
    }
    copyButtonElement.addEventListener("mouseenter", handleButtonMouseEnter);
    copyButtonElement.addEventListener("mouseleave", handleButtonMouseLeave);
    return () => {
        clipboard.destroy();
        tooltip.destroy();
        copyButtonElement.removeEventListener("mouseenter", handleButtonMouseEnter);
        copyButtonElement.removeEventListener("mouseleave", handleButtonMouseLeave);
    };
}
export function initCodeSnippetEvent(blogPostElement) {
    let codeSnippets = blogPostElement.querySelectorAll("pre");
    let removeSnippetCoppyEventList = [];
    for (let i = 0; i < codeSnippets.length; i++) {
        removeSnippetCoppyEventList.push(addSnippetCopyEvent(codeSnippets[i]));
    }
    return () => {
        removeSnippetCoppyEventList.forEach(remove => remove());
    };
}
